var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAwsEc2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-27 0 310 310",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.754,244.495 L12.836,251.321 L12.836,57.565 L42.754,64.404 L42.754,244.495",
    fill: "#F68536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.082,255.931 L42.754,266.539 L42.754,42.612 L80.082,53.207 L80.082,255.931",
    fill: "#F68536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.966,267.681 L80.082,285.205 L80.082,23.946 L127.966,41.462 L127.966,267.681",
    fill: "#F68536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,245.079 L127.966,309.096 L127.966,0 L256,64.017 L256,245.079",
    fill: "#F68536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.444,12.763 L127.966,0 L127.966,309.096 L102.444,296.337 L102.444,12.763",
    fill: "#9D5025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.325,33.82 L80.082,23.942 L80.082,285.154 L60.325,275.276 L60.325,33.82",
    fill: "#9D5025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.016,50.477 L42.754,42.608 L42.754,266.488 L27.016,258.614 L27.016,50.477",
    fill: "#9D5025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.836,57.565 L0,63.983 L0,245.117 L12.836,251.531 L12.836,57.565",
    fill: "#9D5025"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsEc2);
export default __webpack_public_path__ + "static/media/aws-ec2.b9217c0380e0356747bd1959635ca544.svg";
export { ForwardRef as ReactComponent };